import { render, staticRenderFns } from "./CURB65Score.vue?vue&type=template&id=433de69c&scoped=true"
import script from "./CURB65Score.vue?vue&type=script&lang=js"
export * from "./CURB65Score.vue?vue&type=script&lang=js"
import style0 from "./CURB65Score.vue?vue&type=style&index=0&id=433de69c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433de69c",
  null
  
)

export default component.exports